import {Component} from '@angular/core';
import {FieldArrayType, FormlyField} from '@ngx-formly/core';

@Component({
  selector: 'app-repeat-form-field',
  standalone: true,
  styleUrls: ['./repeat-form-field.component.scss'],
  templateUrl: './repeat-form-field.component.html',
  imports: [FormlyField],
})
export class RepeatFormFieldComponent extends FieldArrayType {
  /** TODO: Apply this to the Resource 'Contacts' field.
   *        This creates a repeating field with add/remove, but the internal tracking
   *        of that array isn't functional in formly v7; more work is needed.
  private nextKey = 0;

  addField() {
    const fieldConfig = this.field as FormlyFieldConfig & {fieldGroup: FormlyFieldConfig[]};
    const fieldGroup = fieldConfig.fieldGroup;

    const fieldArrayConfig = this.field.fieldArray as FormlyFieldConfig & {fieldGroup: FormlyFieldConfig[]};

    const newField: FormlyFieldConfig = {
      fieldGroup:
        fieldArrayConfig?.fieldGroup?.map(f => ({
          ...f,
          formControl: new FormGroup({}),
        })) ?? [],
      formControl: new FormGroup({}),
      key: this.nextKey++,
    };

    fieldGroup.push(newField);
    (this.formControl as FormArray).push(newField.formControl);
  }

  removeField(field: FormlyFieldConfig) {
    const fieldConfig = this.field as FormlyFieldConfig & {fieldGroup: FormlyFieldConfig[]};
    const fieldGroup = fieldConfig.fieldGroup;

    const index = fieldGroup.indexOf(field);
    if (index === -1) return;
    (this.formControl as FormArray).removeAt(index);
    fieldGroup.splice(index, 1);
  }
    */
}
